import { useQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

import type { GetUserDetailsResponse } from "../generated-api";

export const userDetails = (userId?: string, options = {}) => {
  return {
    enabled: !!userId,
    queryKey: ["user-details", userId],
    queryFn: async () => {
      if (!userId) {
        throw new Error("userId is required");
      }
      const response = await ApiClient.api.userControllerGetUserDetails({ userId });

      return response.data;
    },
    select: (data: GetUserDetailsResponse) => data.data,
    ...options,
  };
};

export function useUserDetails(userId?: string, options = {}) {
  return useQuery(userDetails(userId, options));
}
